if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	/*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	$('.sym-slides').slick({
		accessibility: false,
		prevArrow: "<button type='button' class='slick-prev slick-arrow'><span>Previous</span></button>",
		nextArrow: "<button type='button' class='slick-next slick-arrow'><span>Previous</span></button>",
	});

	if (document.querySelector('.signup-btn')) {
		let button = document.querySelector('.signup-btn');
		button.setAttribute('aria-label', 'subscribe to our email database');
	}

	if (document.querySelector('#form_id-1118')) {
		let form = document.querySelector('#form_id-1118');
		let submitBTN = form.querySelector('.form-module__submit button');
		let buttonText = submitBTN.textContent;
		console.log(buttonText);
		submitBTN.setAttribute('aria-label', buttonText.toLowerCase());

		// console.log(submitBTN );
	}

	const showBtn = document.querySelector('.show-form');
	const form = document.querySelector('.intro-content__form--form');
	if (showBtn && form) {
		showBtn.addEventListener('click', function() {
			form.classList.add('show');
		});
	}
})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const header = document.querySelector('.new-header');
	const isMenuVisible = header && header.classList.contains('open-nav');
	const primaryNavLinks = document.querySelectorAll('#primary-nav .privary-navigation__item a');
	const logoLink = document.querySelector('.new-header__nav-s-logo a');

	const allNavLinks = [...primaryNavLinks, logoLink];

	allNavLinks.forEach((link) => {
		link.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const header = document.querySelector('.new-header');
	if (header) {
		header.addEventListener('transitionend', updateMenuTabIndex);
	}
});
